import styled from 'styled-components';

export const BaseTableStyled = styled.div`
  padding: 0 20px 10px 20px;
  .paginate {
    display: flex;
    justify-content: center;
  }
`;
